import React from "react";

import { IFeaturedWPPage } from "@app/middleware/api/featured-pages-get.api";
import { PageCard } from "@app/components/page-card/page-card";

import styles from "../search-results.module.scss";

interface IProps {
  headerText: string;
  pages: IFeaturedWPPage[];
  count?: number;
  closeSearch: () => void;
}

const component = ({ headerText, pages, count, closeSearch }: IProps) => {
  return (
    <div className={styles.searchResultContainer}>
      <div className={styles.header}>
        {headerText} {(count || 0) > 0 ? `(${count})` : ""}
      </div>

      <div className={styles.body}>
        <div className={styles.pagePanel}>
          {pages?.map((page, index) => (
            <div key={index} role="button" onClick={closeSearch}>
              <PageCard page={page} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const NavBarResultPages = component;
